import React from 'react';
import clsx from 'clsx';
import type { PressProps } from 'react-aria';
import { ChevronLeft, ChevronRight } from '@danske/sapphire-icons/react';
import styles from '@danske/sapphire-css/components/calendar/calendar.module.css';
import { IconButton } from '../../IconButton';

/**
 * Calendar header shown above the grid.
 * @internal
 */
export function CalendarHeader({
  isLeft,
  isRight,
  children,
  prevButtonProps,
  nextButtonProps,
  size = 'lg',
}: {
  children: React.ReactNode;
  prevButtonProps?: PressProps;
  nextButtonProps?: PressProps;
  isLeft?: boolean;
  isRight?: boolean;
  size?: 'md' | 'lg';
}): React.JSX.Element {
  // The tabIndex is to let the disabled button eat up clicks so that the
  // currently hovered selection in the calendar does not get committed.
  // See https://github.com/adobe/react-spectrum/blob/6618d3812dc3801ce6c110aee1f55e60aa1735f2/packages/%40react-aria/calendar/src/useRangeCalendar.ts#L55
  return (
    <div
      className={clsx(styles['sapphire-calendar__header'], {
        [styles['sapphire-calendar__header--left']]: isLeft,
        [styles['sapphire-calendar__header--right']]: isRight,
      })}
    >
      <div
        className={styles['sapphire-calendar__header-prev-month']}
        tabIndex={prevButtonProps?.isDisabled ? -1 : undefined}
      >
        <IconButton
          {...prevButtonProps}
          variant="tertiary"
          size={size}
          aria-label="Previous"
        >
          <ChevronLeft />
        </IconButton>
      </div>
      <div className={styles['sapphire-calendar__header-title']}>
        {children}
      </div>
      <div
        className={styles['sapphire-calendar__header-next-month']}
        tabIndex={nextButtonProps?.isDisabled ? -1 : undefined}
      >
        <IconButton
          {...nextButtonProps}
          variant="tertiary"
          size={size}
          aria-label="Next"
        >
          <ChevronRight />
        </IconButton>
      </div>
    </div>
  );
}
